import {
  Box,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
  Image,
  HStack,
  VStack,
  Checkbox,
  CheckboxGroup,
  Badge,
  Wrap,
  WrapItem,
  Flex,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Switch,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Divider,
  Card,
  RadioGroup,
  Radio,
  Textarea,
  InputRightAddon,
  InputLeftAddon,
  Stack,
  Center,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import {
  MdLocationOn,
  MdVisibility,
  MdEdit,
  MdDelete,
  MdSearch,
  MdAdd,
  MdMoreVert,
  MdGridView,
  MdList,
  MdChevronLeft,
  MdChevronRight,
  MdWork,
  MdCheckCircle,
  MdPause,
  MdFavorite,
  MdArrowUpward,
  MdArrowDownward,
  MdEmail,
  MdPhone,
  MdCameraAlt,
  MdContentCopy,
  MdArrowBack,
  MdCall,
  MdStar,
  MdStarOutline,
  MdAccessTime,
  MdSpeed,
  MdThumbUp,
} from "react-icons/md";
import StaffStatCard from "components/card/StaffStatCard";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getUsers, getUser, getUsersid, checkToken, updateUser, createUser, deleteUser, getAllPatients, getUserPerformance, getSites, getUserSites, getAllUsersWithSites, changeUserSite, removeUserFromSite } from "../../../api/api";
import axios from "axios";
import { BASE_URL } from "config/api";
import { useNavbarAction } from "contexts/NavbarActionContext";
import LoadingSpinner from "components/LoadingSpinner";
import { validateEmail, validatePhone, validationMessages } from "utils/validation";
import { usePermissions } from "hooks/usePermissions";

const StatusBadge = ({ status }) => {
  const statusConfig = {
    actif: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Actif"
    },
    active: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Actif"
    },
    inactif: {
      bg: "#FDF2F2",
      border: "#FBD5D5",
      text: "#9B1C1C",
      label: "Inactif"
    },
    'en mission': {
      bg: "#EBF8FF",
      border: "#BEE3F8",
      text: "#2B6CB0",
      label: "En mission"
    },
    'en_mission': {
      bg: "#EBF8FF",
      border: "#BEE3F8",
      text: "#2B6CB0",
      label: "En mission"
    },
    'en pause': {
      bg: "#FFF5F5",
      border: "#FEB2B2",
      text: "#C53030",
      label: "En pause"
    },
    'pause': {
      bg: "#FFF5F5",
      border: "#FEB2B2",
      text: "#C53030",
      label: "En pause"
    }
  };

  const normalizedStatus = status?.toLowerCase() || 'actif';
  const config = statusConfig[normalizedStatus] || {
    bg: "#F7FAFC",
    border: "#E2E8F0",
    text: "#4A5568",
    label: status
  };

  return (
    <HStack
      spacing={2}
      bg={config.bg}
      border="1px solid"
      borderColor={config.border}
      px={3}
      py={1}
      borderRadius="full"
      w="fit-content"
      align="center"
    >
      <Box w="8px" h="8px" borderRadius="full" bg={config.text} />
      <Text fontSize="13px" fontWeight="600" color={config.text}>
        {config.label}
      </Text>
    </HStack>
  );
};

export default function UserSettings() {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const { navbarHeight, setOnCreateUtilisateur, showStats, setShowStats } = useNavbarAction();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [viewData, setViewData] = useState(null);
  const cancelRef = useRef();
  const toast = useToast();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  // Edit Modal
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [initialData, setInitialData] = useState(null);
  const [unsaved, setUnsaved] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [viewMode, setViewMode] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserDetail, setSelectedUserDetail] = useState(null);
  const [isDetailPanelOpen, setIsDetailPanelOpen] = useState(false);
  const [userMissions, setUserMissions] = useState([]);
  const [missionSearchQuery, setMissionSearchQuery] = useState("");
  const [missionStatusFilter, setMissionStatusFilter] = useState("all");
  const [missionCurrentPage, setMissionCurrentPage] = useState(1);
  const [missionItemsPerPage, setMissionItemsPerPage] = useState(20);
  const [userPatients, setUserPatients] = useState([]);
  const [patientSearchQuery, setPatientSearchQuery] = useState("");
  const [patientStatusFilter, setPatientStatusFilter] = useState("all");
  const [patientViewMode, setPatientViewMode] = useState("grid");
  const [patientCurrentPage, setPatientCurrentPage] = useState(1);
  const [patientItemsPerPage, setPatientItemsPerPage] = useState(20);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [userPerformance, setUserPerformance] = useState(null);
  const [loadingPerformance, setLoadingPerformance] = useState(false);

  // Site management state
  const [allSites, setAllSites] = useState([]);
  const [userSiteMap, setUserSiteMap] = useState({}); // { userId: { SiteID, SiteName } }
  const [siteChangeUser, setSiteChangeUser] = useState(null);
  const [selectedSiteId, setSelectedSiteId] = useState("");
  const [siteChangeLoading, setSiteChangeLoading] = useState(false);
  const {
    isOpen: isSiteChangeOpen,
    onOpen: onSiteChangeOpen,
    onClose: onSiteChangeClose,
  } = useDisclosure();

  // Add Modal
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();
  const [newUserData, setNewUserData] = useState({
    nom: "",
    prenom: "",
    email: "",
    mot_de_passe: "",
    rôle: "médecin",
    téléphone: "",
    statut: "actif",
    genre: "femme",
    date_naissance: "",
    ville: "",
    photo: "",
    perm: [],
    specialty: "",
    compte_actif: true,
    à_propos: "",
  });
  const [photoPreview, setPhotoPreview] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);

  // Fonction pour générer un mot de passe aléatoire
  const generatePassword = () => {
    const length = 14;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setNewUserData(prev => ({ ...prev, mot_de_passe: password }));
    return password;
  };

  // Générer un mot de passe au chargement du modal
  useEffect(() => {
    if (isAddOpen) {
      generatePassword();
    }
  }, [isAddOpen]);

  // Fonction pour copier le mot de passe
  const copyPassword = () => {
    navigator.clipboard.writeText(newUserData.mot_de_passe);
    toast({
      title: "Mot de passe copié",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  // Fonction pour gérer l'upload de photo
  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match(/image\/(jpg|jpeg|png|gif)/)) {
      toast({ title: 'Format invalide. Utilisez JPG, PNG ou GIF', status: 'error', isClosable: true });
      return;
    }

    // Validate file size (2MB max)
    if (file.size > 2 * 1024 * 1024) {
      toast({ title: 'Le fichier ne doit pas dépasser 2 Mo', status: 'error', isClosable: true });
      return;
    }

    setProfilePhoto(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoPreview(reader.result);
      setNewUserData(prev => ({ ...prev, photo: reader.result }));
    };
    reader.readAsDataURL(file);
  };


  const {
    isOpen: isAlertOpen,
    onOpen: onAlertOpen,
    onClose: onAlertClose,
  } = useDisclosure();

  // View Modal
  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  // Liste des villes du Maroc
  const villesMaroc = [
    "Agadir", "Agdz", "Aït Melloul", "Al Hoceïma", "Arfoud", "Asilah", "Azemmour", "Azrou", "Beni Mellal", "Ben Guerir", "Berkane", "Berrechid", "Bouarfa", "Boujdour", "Boulemane", "Bouskoura", "Casablanca", "Chefchaouen", "Chichaoua", "Dakhla", "Demnate", "Drarga", "El Hajeb", "El Jadida", "Errachidia", "Essaouira", "Fès", "Fnideq", "Guelmim", "Guercif", "Ifrane", "Imzouren", "Inezgane", "Jerada", "Jorf El Melha", "Kénitra", "Khémisset", "Khénifra", "Khouribga", "Ksar El Kebir", "Laâyoune", "Larache", "Lqliaa", "Marrakech", "Martil", "Meknès", "Midelt", "Mohammédia", "Nador", "Nouaceur", "Ouarzazate", "Oued Zem", "Oujda", "Oulad Teima", "Rabat", "Rissani", "Rommani", "Safi", "Salé", "Sefrou", "Settat", "Sidi Bennour", "Sidi Ifni", "Sidi Kacem", "Sidi Slimane", "Skhirat", "Tafraout", "Tan-Tan", "Tanger", "Taourirt", "Tarfaya", "Taroudant", "Taza", "Témara", "Tétouan", "Tiflet", "Youssoufia", "Tiznit", "Zagora"
  ];

  // Liste des permissions disponibles par page
  const permissionsConfig = [
    { page: "dashboard", label: "Dashboard", perms: ["view", "read"] },
    { page: "missions", label: "Missions", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "vehicules", label: "Ambulances", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "materiels", label: "Matériels", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "utilisateurs", label: "Utilisateurs", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "patients", label: "Patients", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "avis", label: "Avis", perms: ["view", "read"] },
    { page: "reclamations", label: "Réclamations", perms: ["view", "read", "create"] },
    { page: "analyses", label: "Analyses", perms: ["view", "read"] },
    { page: "gps", label: "GPS Map", perms: ["view", "read"] },
    { page: "stock", label: "Gestion Stock", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "pointage", label: "Pointage de suivi", perms: ["view", "read", "create"] },
    { page: "profile", label: "Profile", perms: ["view", "read", "edit"] },
    { page: "adherents", label: "Adhérents", perms: ["view", "read", "create", "edit", "delete"] },
    { page: "logs", label: "Logs d'Audit", perms: ["view"] },
  ];

  // Labels pour les permissions
  const permLabels = {
    view: "Accès Page",
    read: "Lecture",
    create: "Création",
    edit: "Modification",
    delete: "Suppression"
  };

  // Load sites list once
  useEffect(() => {
    getSites().then((res) => setAllSites(res.data)).catch(() => { });
  }, []);

  useEffect(() => {
    const checkTokenAndUser = async () => {
      try {
        // 1. Vérifier la validité de la session
        const check = await checkToken(); // le backend lit le cookie
        if (!check.data.valid) {
          navigate('/auth/sign-in');
          return;
        }

        // 2. Récupérer les infos utilisateur
        const user = await getUser(); // le backend lit le cookie
        const userRole = user.rôle || user['rÃ´le'] || user.role;
        if (
          userRole !== 'admin' &&
          userRole !== 'régulateur' &&
          userRole !== 'rÃ©gulateur' &&
          userRole !== 'médecin regulateur' &&
          userRole !== 'medecin regulateur'
        ) {
          navigate('/auth/sign-in');
          return;
        }

        // Si tout est ok, on charge les données
        fetchData();
      } catch (error) {
        console.error("Error:", error);
        navigate('/auth/sign-in');
      }
    };
    checkTokenAndUser();
  }, [navigate]);


  useEffect(() => {
    fetchData();
  }, []);

  // Configurer le contexte NavbarActionContext pour la navbar
  useEffect(() => {
    if (hasPermission('utilisateurs_create')) {
      setOnCreateUtilisateur(() => onAddOpen);
    }
    return () => {
      setOnCreateUtilisateur(null);
    };
  }, [onAddOpen, setOnCreateUtilisateur, hasPermission]);

  // Charge le site actuel de chaque utilisateur (1 seul appel API)
  const fetchUserSiteMap = async () => {
    try {
      const res = await getAllUsersWithSites();
      const map = {};
      res.data.forEach((u) => {
        if (u.SiteID) {
          const currentStartDate = u.StartDate ? new Date(u.StartDate) : new Date(0);

          if (!map[u.id]) {
            map[u.id] = { SiteID: u.SiteID, SiteName: u.SiteName, UserSiteID: u.UserSiteID, StartDate: currentStartDate };
          } else {
            if (currentStartDate > map[u.id].StartDate) {
              map[u.id] = { SiteID: u.SiteID, SiteName: u.SiteName, UserSiteID: u.UserSiteID, StartDate: currentStartDate };
            }
          }
        }
      });
      setUserSiteMap(map);
    } catch (err) {
      console.error('Error fetching user site map:', err);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const usersRes = await getUsers();

      // L'API parse déjà le perm automatiquement via decryptUserData
      const newData = usersRes.data.map(user => ({
        ...user,
        perm: Array.isArray(user.perm) ? user.perm : []
      }));

      setTableData(newData);
      // Load site info for each user in background
      fetchUserSiteMap();
    } catch (err) {
      console.error("Fetch error:", err);
      toast({ title: "Error fetching data", status: "error", isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  // Open the change-site modal for a user
  const openSiteChange = (row) => {
    const user = tableData.find((u) => u.id === row.id) || row;
    setSiteChangeUser(user);
    setSelectedSiteId(userSiteMap[row.id]?.SiteID?.toString() || "");
    onSiteChangeOpen();
  };

  // Handle saving the site change
  const handleChangeSite = async () => {
    if (!selectedSiteId) {
      toast({ title: "Veuillez sélectionner un site", status: "warning", isClosable: true });
      return;
    }
    try {
      setSiteChangeLoading(true);
      await changeUserSite(siteChangeUser.id, {
        SiteID: parseInt(selectedSiteId),
        StartDate: new Date().toISOString().split("T")[0],
      });
      const site = allSites.find((s) => s.SiteID === parseInt(selectedSiteId));
      setUserSiteMap((prev) => ({
        ...prev,
        [siteChangeUser.id]: { SiteID: parseInt(selectedSiteId), SiteName: site?.SiteName || "" },
      }));
      toast({ title: "Site mis à jour avec succès", status: "success", isClosable: true });
      onSiteChangeClose();
    } catch (err) {
      toast({
        title: "Erreur lors du changement de site",
        description: err.response?.data?.error,
        status: "error",
        isClosable: true,
      });
    } finally {
      setSiteChangeLoading(false);
    }
  };

  // Remove user from all sites
  const handleRemoveSite = async () => {
    const siteInfo = userSiteMap[siteChangeUser.id];
    if (!siteInfo?.UserSiteID) {
      // Try to fetch to get the UserSiteID
      try {
        const res = await getUserSites(siteChangeUser.id);
        if (res.data.length === 0) {
          toast({ title: "Cet utilisateur n'a aucun site assigné", status: "info", isClosable: true });
          return;
        }
        for (const assignment of res.data) {
          await removeUserFromSite(assignment.UserSiteID);
        }
      } catch { }
    } else {
      await removeUserFromSite(siteInfo.UserSiteID);
    }
    setUserSiteMap((prev) => {
      const updated = { ...prev };
      delete updated[siteChangeUser.id];
      return updated;
    });
    toast({ title: "Site retiré avec succès", status: "success", isClosable: true });
    onSiteChangeClose();
  };

  const handleEdit = async (id) => {
    try {
      const res = await getUsersid(id);


      // L'API parse déjà le perm automatiquement via decryptUserData
      const userData = {
        ...res.data,
        perm: Array.isArray(res.data.perm) ? res.data.perm : []
      };


      setInitialData(userData);
      setEditData(userData);
      setUnsaved(false);
      setSelectedId(id);
      onEditOpen();
    } catch (err) {

      console.error('Erreur complète:', err);
      console.error('Message d\'erreur:', err.message);

    }
  };

  const handleSave = async () => {
    try {
      // Nettoyer les permissions pour ne garder que le nouveau format
      // validPermissions est calculé dynamiquement à partir de permissionsConfig
      const cleanedPerms = Array.isArray(editData.perm)
        ? editData.perm.filter(p => validPermissions.includes(p))
        : [];

      // Préparer les données à envoyer avec les permissions nettoyées
      const dataToSave = {
        ...editData,
        perm: cleanedPerms
      };

      // L'API gère automatiquement la conversion via validateJSON
      const response = await updateUser(selectedId, dataToSave);

      setTableData(prevData => {
        const newData = prevData.map(item =>
          item.id === selectedId ? { ...item, ...dataToSave } : item
        );
        return newData;
      });

      // Debug: Afficher les données après mise à jour


      toast({ title: "Updated", status: "success", isClosable: true });
      onEditClose();
      setEditData(null);
      setInitialData(null);
    } catch (err) {
      // Debug: Afficher l'erreur détaillée

      console.error('Erreur complète:', err);
      console.error('Message d\'erreur:', err.message);



      toast({ title: "Update failed", status: "error", isClosable: true });
    }
  };

  const handleAdd = async () => {
    // Validation du nom et prénom
    if (!newUserData.nom || !newUserData.prenom) {
      toast({ title: "Veuillez saisir le nom et le prénom", status: "error", isClosable: true });
      return;
    }

    // Validation de l'email
    if (!validateEmail(newUserData.email)) {
      toast({
        title: validationMessages.email.invalid,
        status: "error",
        isClosable: true,
        duration: 4000
      });
      return;
    }

    // Validation du téléphone
    if (!validatePhone(newUserData.téléphone)) {
      toast({
        title: validationMessages.phone.invalid,
        status: "error",
        isClosable: true,
        duration: 4000
      });
      return;
    }

    // Validation des champs requis
    const requiredFields = [
      "email",
      "mot_de_passe",
      "rôle",
      "téléphone",
      "date_naissance",
      "ville",
    ];

    for (let field of requiredFields) {
      if (!newUserData[field] || newUserData[field] === "") {
        toast({ title: `Veuillez remplir le champ "${field}"`, status: "error", isClosable: true });
        return;
      }
    }

    try {
      // Préparer les données à envoyer
      const userDataToSend = {
        nom: newUserData.nom,
        prenom: newUserData.prenom,
        email: newUserData.email,
        mot_de_passe: newUserData.mot_de_passe,
        rôle: newUserData.rôle,
        téléphone: newUserData.téléphone,
        statut: newUserData.compte_actif ? "actif" : "inactif",
        genre: newUserData.genre,
        date_naissance: newUserData.date_naissance,
        ville: newUserData.ville,
        photo: newUserData.photo || "https://img.freepik.com/vecteurs-premium/icones-utilisateur-comprend-icones-utilisateur-symboles-icones-personnes-elements-conception-graphique-qualite-superieure_981536-526.jpg",
        perm: newUserData.perm || [],
        specialty: newUserData.specialty || "",
      };

      // L'API gère automatiquement la conversion via validateJSON
      const response = await createUser(userDataToSend);
      setTableData(prevData => {
        const newData = [...prevData, { ...userDataToSend, id: response.data.id }];
        return newData;
      });
      toast({ title: "Utilisateur ajouté avec succès", status: "success", isClosable: true });
      onAddClose();
      resetAddForm();
    } catch (err) {
      console.error("Add error:", err);
      toast({ title: "Erreur lors de l'ajout", status: "error", isClosable: true });
    }
  };

  const handleCloseEdit = () => {
    if (JSON.stringify(editData) !== JSON.stringify(initialData)) {
      const confirmClose = window.confirm("Unsaved changes detected. Do you want to discard?");
      if (!confirmClose) return;
    }
    onEditClose();
  };

  const handleRemove = (id) => {
    setSelectedId(id);
    onAlertOpen();
  };

  const confirmDelete = async () => {
    try {
      await deleteUser(selectedId);
      toast({ title: "Deleted", status: "success", isClosable: true });
      onAlertClose();
      setTableData(prevData => {
        const newData = prevData.filter(item => item.id !== selectedId);
        return newData;
      });
    } catch (err) {
      toast({ title: "Delete failed", status: "error", isClosable: true });
    }
  };

  const updateField = (field, value) => {
    setEditData(prev => {
      const newData = { ...prev, [field]: value };
      return newData;
    });
    setUnsaved(true);
  };

  // Liste des permissions valides (nouveau format)
  const validPermissions = [
    "allaccess",
    ...permissionsConfig.flatMap(config =>
      config.perms.map(perm => `${config.page}_${perm}`)
    )
  ];

  // Fonction pour nettoyer les permissions (garder seulement le nouveau format)
  const cleanPermissions = (perms) => {
    if (!Array.isArray(perms)) return [];
    return perms.filter(p => validPermissions.includes(p));
  };

  const updatePermissions = (permissions) => {
    setEditData(prev => {
      // S'assurer que perm est toujours un array valide et nettoyé
      const permValue = Array.isArray(permissions) ? permissions : [];
      // Garder seulement les permissions du nouveau format
      const cleanedPerms = cleanPermissions(permValue);
      const newData = { ...prev, perm: cleanedPerms };
      return newData;
    });
    setUnsaved(true);
  };

  const updateAddField = (field, value) => {
    setNewUserData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };
      return newData;
    });
  };

  // Fonction pour réinitialiser le formulaire
  const resetAddForm = () => {
    setNewUserData({
      nom: "",
      prenom: "",
      email: "",
      mot_de_passe: "",
      rôle: "médecin",
      téléphone: "",
      statut: "actif",
      genre: "femme",
      date_naissance: "",
      ville: "",
      photo: "",
      perm: [],
      specialty: "",
      compte_actif: true,
      à_propos: "",
    });
    setPhotoPreview(null);
    setProfilePhoto(null);
    generatePassword();
  };

  const updateAddPermissions = (permissions) => {
    setNewUserData((prev) => ({
      ...prev,
      perm: permissions,
    }));
  };

  const handleEditPhotoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.match(/image\/(jpg|jpeg|png|gif)/)) {
      toast({ title: 'Format invalide. Utilisez JPG, PNG ou GIF', status: 'error', isClosable: true });
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      toast({ title: 'Le fichier ne doit pas dépasser 2 Mo', status: 'error', isClosable: true });
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      updateField("photo", reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleView = async (id) => {
    try {
      const res = await getUsersid(id);

      // L'API parse déjà le perm automatiquement via decryptUserData
      const userData = {
        ...res.data,
        perm: Array.isArray(res.data.perm) ? res.data.perm : []
      };

      setViewData(userData);
      onViewOpen();

      // Charger les missions, patients et performances de l'utilisateur
      await Promise.all([
        fetchUserMissions(id),
        fetchUserPatients(id),
        fetchUserPerformance(id)
      ]);
    } catch (err) {
      console.error(err);
      toast({ title: "Error fetching user details", status: "error", isClosable: true });
    }
  };

  // Fonction pour charger les performances de l'utilisateur
  const fetchUserPerformance = async (userId) => {
    try {
      setLoadingPerformance(true);
      const res = await getUserPerformance(userId);
      setUserPerformance(res.data.performance_user);
    } catch (err) {
      console.error("Error fetching user performance:", err);
      setUserPerformance(null);
    } finally {
      setLoadingPerformance(false);
    }
  };

  // Fonction pour charger les missions de l'utilisateur
  const fetchUserMissions = async (userId) => {
    try {
      const missionsRes = await axios.get(`${BASE_URL}/missions`, {
        withCredentials: true,
      });

      // Filtrer les missions où l'utilisateur est impliqué (ambulancier, médecin, infirmier)
      const userMissionsList = missionsRes.data.filter(mission =>
        mission.ambulancier_id === userId ||
        mission.médecin_id === userId ||
        mission.infirmier_id === userId
      );

      setUserMissions(userMissionsList);
    } catch (err) {
      console.error("Error fetching user missions:", err);
      setUserMissions([]);
    }
  };

  // Fonction pour charger les patients de l'utilisateur
  const fetchUserPatients = async (userId) => {
    try {

      // Charger les missions pour trouver les patients associés
      const missionsRes = await axios.get(`${BASE_URL}/missions`, {
        withCredentials: true,
      });

      // Filtrer les missions où l'utilisateur est impliqué
      const userMissionsList = missionsRes.data.filter(mission =>
        mission.ambulancier_id === userId ||
        mission.médecin_id === userId ||
        mission.infirmier_id === userId
      );

      // Extraire les IDs des patients uniques
      const patientIds = [...new Set(
        userMissionsList
          .map(mission => mission.patient_id)
          .filter(id => id != null)
      )];

      // Charger tous les patients
      const patientsRes = await getAllPatients();

      // Support pour la nouvelle structure paginée et l'ancienne structure
      let allPatients = [];
      if (Array.isArray(patientsRes.data?.data)) {
        allPatients = patientsRes.data.data;
      } else if (Array.isArray(patientsRes.data)) {
        allPatients = patientsRes.data;
      }

      // Filtrer les patients associés aux missions
      const userPatientsList = allPatients.filter(patient =>
        patientIds.includes(patient.id)
      );

      setUserPatients(userPatientsList);
    } catch (err) {
      console.error("Error fetching user patients:", err);
      setUserPatients([]);
    }
  };


  // Fonction pour ouvrir le panneau de détails
  const openDetailPanel = async (row) => {
    try {
      // Afficher le panneau immédiatement avec les données de base de la ligne
      setSelectedUserDetail(row);
      setIsDetailPanelOpen(true);

      const res = await getUsersid(row.id);
      const userData = {
        ...res.data,
        perm: Array.isArray(res.data.perm) ? res.data.perm : []
      };
      setSelectedUserDetail(userData);
    } catch (err) {
      console.error(err);
      // On ne ferme pas le panneau, on garde les données de base si le fetch échoue
      toast({ title: "Erreur lors du chargement des détails complets", status: "warning", isClosable: true });
    }
  };

  const truncateText = (text, maxLength = 20) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const mappedTableData = useMemo(() => {
    return tableData.map((row) => ({
      id: row.id,
      nom: row.nom || '',
      prenom: row.prenom || '',
      email: row.email || '',
      rôle: row.rôle || '',
      téléphone: row.téléphone || '',
      statut: row.statut || '',
      genre: row.genre || '',
      date_naissance: row.date_naissance ? new Date(row.date_naissance).toLocaleDateString("fr-FR") : '',
      photo: row.photo || "https://img.freepik.com/vecteurs-premium/icones-utilisateur-comprend-icones-utilisateur-symboles-icones-personnes-elements-conception-graphique-qualite-superieure_981536-526.jpg",
      ville: row.ville || '',
      specialty: row.specialty || '',
    }));
  }, [tableData]);

  // Calcul des statistiques
  const stats = useMemo(() => {
    const total = tableData.length;
    const enMission = tableData.filter(user => {
      const statut = (user.statut || '').toLowerCase();
      return statut === 'en mission' || statut === 'en_mission';
    }).length;
    const disponibles = tableData.filter(user => {
      const statut = (user.statut || '').toLowerCase();
      return statut === 'actif' || statut === 'active';
    }).length;
    const enPause = tableData.filter(user => {
      const statut = (user.statut || '').toLowerCase();
      return statut === 'en pause' || statut === 'en_pause' || statut === 'pause';
    }).length;

    return {
      total,
      enMission,
      disponibles,
      enPause,
    };
  }, [tableData]);

  // Compteurs par catégorie
  const categoryCounts = useMemo(() => {
    return {
      all: tableData.length,
      médecin: tableData.filter(u => u.rôle === 'médecin' || u.rôle === 'Médecin').length,
      "médecin regulateur": tableData.filter(
        u =>
          u.rôle === 'médecin regulateur' ||
          u.rôle === 'medecin regulateur' ||
          u.rôle === 'Médecin regulateur'
      ).length,
      infirmier: tableData.filter(u => u.rôle === 'infirmier' || u.rôle === 'Infirmier').length,
      ambulancier: tableData.filter(u => u.rôle === 'ambulancier' || u.rôle === 'Ambulancier').length,
      admin: tableData.filter(u => u.rôle === 'admin' || u.rôle === 'Admin').length,
      régulateur: tableData.filter(u => u.rôle === 'régulateur' || u.rôle === 'Régulateur').length,
    };
  }, [tableData]);

  const filteredData = useMemo(() => {
    let filtered = mappedTableData;

    // Filtre par recherche
    if (searchQuery) {
      filtered = filtered.filter((row) => {
        const searchFields = [
          row.nom,
          row.prenom,
          row.email,
          row.rôle,
          row.téléphone,
          row.statut,
          row.genre,
          row.date_naissance,
        ];

        return searchFields.some(field =>
          field && field.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });
    }

    // Filtre par catégorie
    if (categoryFilter !== "all") {
      filtered = filtered.filter((row) => {
        const role = row.rôle?.toLowerCase() || '';
        return role === categoryFilter.toLowerCase();
      });
    }

    // Filtre par statut
    if (statusFilter !== "all") {
      filtered = filtered.filter((row) => {
        const statut = row.statut?.toLowerCase() || '';
        return statut === statusFilter.toLowerCase();
      });
    }

    return filtered;
  }, [mappedTableData, searchQuery, categoryFilter, statusFilter]);

  // Pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  if (loading) {
    const topPadding = navbarHeight > 0 ? `${navbarHeight}px` : '200px';
    return (
      <Box minH="100vh" bg={bgColor} px={6} pb={6} pt={0}>
        <Box maxW="9xl" mx="auto" pt={topPadding} transition="padding-top 0.3s ease">
          <LoadingSpinner message="Chargement des utilisateurs..." size="lg" fullHeight />
        </Box>
      </Box>
    );
  }

  const topPadding = navbarHeight > 0 ? `${navbarHeight}px` : '200px';

  return (
    <Box minH="100vh" bg={bgColor} px={6} pb={6} pt={0}>
      <Box maxW="9xl" mx="auto" pt={topPadding} transition="padding-top 0.3s ease, margin-right 0.3s" mr={isDetailPanelOpen ? "400px" : "auto"}>
        <VStack spacing={6} align="stretch">

          {/* Statistics Section */}
          {showStats && (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={6}>
              <StaffStatCard
                title="Nombre total d'utilisateurs"
                value={stats.total}
                percentage="+0%"
                subtitle="Growth vs semaine précédente"
                icon={MdWork}
                iconColor="#459CE9"
                isPositive={true}
              />
              <StaffStatCard
                title="En Mission maintenant"
                value={stats.enMission}
                subtitle="Engagés dans une mission en cour"
                icon={MdFavorite}
                iconColor="#F8285A"
                isPositive={true}
              />
              <StaffStatCard
                title="Disponibles maintenant"
                value={stats.disponibles}
                subtitle="Disponible pour recevoir des missions"
                icon={MdCheckCircle}
                iconColor="#29BACD"
                isPositive={true}
              />
              <StaffStatCard
                title="En Pause"
                value={stats.enPause}
                subtitle="Utilisateurs indisponibles"
                icon={MdPause}
                iconColor="#F8285A"
                isPositive={false}
              />
            </SimpleGrid>
          )}

          {/* Filters Section */}
          <Box bg={cardBg} borderRadius="12px" p={4} mb={4}>
            <VStack spacing={4} align="stretch">
              {/* Category Filters */}
              <HStack spacing={2} flexWrap="wrap">
                <Button
                  size="sm"
                  variant={categoryFilter === "all" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "all" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("all")}
                  borderRadius="md"
                >
                  Tout
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "médecin" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "médecin" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("médecin")}
                  borderRadius="md"
                >
                  Médecins {categoryCounts.médecin > 0 && `(${categoryCounts.médecin})`}
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "médecin regulateur" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "médecin regulateur" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("médecin regulateur")}
                  borderRadius="md"
                >
                  Médecin régulateur {categoryCounts["médecin regulateur"] > 0 && `(${categoryCounts["médecin regulateur"]})`}
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "infirmier" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "infirmier" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("infirmier")}
                  borderRadius="md"
                >
                  Infirmiers {categoryCounts.infirmier > 0 && `(${categoryCounts.infirmier})`}
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "ambulancier" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "ambulancier" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("ambulancier")}
                  borderRadius="md"
                >
                  Ambulanciers {categoryCounts.ambulancier > 0 && `(${categoryCounts.ambulancier})`}
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "admin" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "admin" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("admin")}
                  borderRadius="md"
                >
                  Admin {categoryCounts.admin > 0 && `(${categoryCounts.admin})`}
                </Button>
                <Button
                  size="sm"
                  variant={categoryFilter === "régulateur" ? "solid" : "outline"}
                  colorScheme={categoryFilter === "régulateur" ? "blue" : "gray"}
                  onClick={() => setCategoryFilter("régulateur")}
                  borderRadius="md"
                >
                  Régulateur {categoryCounts.régulateur > 0 && `(${categoryCounts.régulateur})`}
                </Button>
              </HStack>

              {/* Search and Controls */}
              <Flex gap={4} align="center" flexWrap="wrap">
                <InputGroup maxW="400px" flex="1" minW="250px">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={MdSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Recherche d'une personnels..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    bg="white"
                    borderRadius="md"
                  />
                </InputGroup>
                <Menu>

                  <MenuList>
                    <MenuItem>Colonnes personnalisées</MenuItem>
                  </MenuList>
                </Menu>
                <Select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                  maxW="200px"
                  size="sm"
                  bg="white"
                >
                  <option value="all">Statut: Tous</option>
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                  <option value="en mission">En Mission</option>
                  <option value="en pause">En Pause</option>
                </Select>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdGridView />}
                    aria-label="Vue grille"
                    size="sm"
                    variant={viewMode === "grid" ? "solid" : "outline"}
                    colorScheme={viewMode === "grid" ? "blue" : "gray"}
                    onClick={() => setViewMode("grid")}
                  />
                  <IconButton
                    icon={<MdList />}
                    aria-label="Vue liste"
                    size="sm"
                    variant={viewMode === "list" ? "solid" : "outline"}
                    colorScheme={viewMode === "list" ? "blue" : "gray"}
                    onClick={() => setViewMode("list")}
                  />
                </HStack>
              </Flex>
            </VStack>
          </Box>

          {/* Table/Grid Section */}
          <Box bg={cardBg} borderRadius="12px" p={6}>
            {viewMode === "list" ? (
              <TableContainer border="1px solid" borderColor="gray.200" borderRadius="12px" overflowX="auto">
                <Table variant="simple" minW="1300px" sx={{ 'th, td': { borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'gray.200', whiteSpace: 'nowrap' }, 'th:last-child, td:last-child': { borderRight: 'none' }, 'tr:last-child td': { borderBottom: 'none' } }}>
                  <Thead>
                    <Tr bg="gray.50">
                      <Th w="80px">ID</Th>
                      <Th minW="250px">Nom & Prénom</Th>
                      <Th w="150px">Type</Th>
                      <Th minW="250px">Contact</Th>
                      <Th w="150px">Ville</Th>
                      <Th w="200px">Site</Th>
                      <Th w="180px">Statut</Th>
                      <Th w="80px">Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {paginatedData.length === 0 ? (
                      <Tr>
                        <Td colSpan={10} textAlign="center" py={8}>
                          <Text color="gray.500">Aucun personnel trouvé</Text>
                        </Td>
                      </Tr>
                    ) : (
                      paginatedData.map((row) => {
                        const user = tableData.find(u => u.id === row.id);
                        const fullName = `${row.prenom || ''} ${row.nom || ''}`.trim() || 'N/A';
                        const role = row.rôle || '';
                        const city = row.ville || user?.ville || '---';
                        const status = row.statut || '---';

                        return (
                          <Tr
                            key={row.id}
                            _hover={{ bg: "gray.50", cursor: "pointer" }}
                            bg={selectedUserDetail?.id === row.id ? "blue.50" : "transparent"}
                            onClick={() => openDetailPanel(row)}
                          >
                            <Td fontWeight="medium">P-{String(row.id).padStart(3, '0')}</Td>
                            <Td>
                              <HStack spacing={2}>
                                <Avatar size="sm" src={user?.photo || row.photo} name={fullName} borderRadius="0px" />
                                <VStack align="start" spacing={0}>
                                  <Text fontWeight="medium">{fullName}</Text>
                                  <Text fontSize="xs" color="gray.500">
                                    {role === 'médecin regulateur' || role === 'medecin regulateur' ? 'Médecin régulateur' :
                                      role === 'médecin' ? 'Médecin spécialiste' :
                                      role === 'infirmier' ? 'Soins Intensifs' :
                                        role === 'ambulancier' ? 'Transport médicalisé' : role}
                                  </Text>
                                </VStack>
                              </HStack>
                            </Td>
                            <Td>{role.charAt(0).toUpperCase() + role.slice(1)}</Td>
                            <Td>
                              <VStack align="start" spacing={0}>
                                <Text fontSize="sm">{row.email || '---'}</Text>
                                <Text fontSize="xs" color="gray.500">{row.téléphone || ''}</Text>
                              </VStack>
                            </Td>
                            <Td>{city}</Td>
                            <Td onClick={(e) => e.stopPropagation()}>
                              {userSiteMap[row.id] ? (
                                <Badge
                                  colorScheme="teal"
                                  borderRadius="full"
                                  px={2}
                                  py={1}
                                  cursor="pointer"
                                  onClick={() => openSiteChange(row)}
                                  title="Cliquer pour changer de site"
                                >
                                  📍 {userSiteMap[row.id].SiteName}
                                </Badge>
                              ) : (
                                <Button
                                  size="xs"
                                  variant="outline"
                                  colorScheme="gray"
                                  onClick={() => openSiteChange(row)}
                                >
                                  + Assigner
                                </Button>
                              )}
                            </Td>
                            <Td>
                              <StatusBadge status={status} />
                            </Td>
                            <Td onClick={(e) => e.stopPropagation()}>
                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Actions"
                                />
                                <MenuList>
                                  <MenuItem icon={<MdVisibility />} onClick={() => handleView(row.id)}>
                                    Voir
                                  </MenuItem>
                                  {hasPermission('utilisateurs_edit') && (
                                    <MenuItem icon={<MdEdit />} onClick={() => handleEdit(row.id)}>
                                      Modifier
                                    </MenuItem>
                                  )}
                                  <MenuItem icon={<MdLocationOn />} onClick={() => openSiteChange(row)}>
                                    Changer de Site
                                  </MenuItem>
                                  {hasPermission('utilisateurs_delete') && (
                                    <MenuItem icon={<MdDelete />} onClick={() => handleRemove(row.id)} color="red.500">
                                      Supprimer
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Td>
                          </Tr>
                        );
                      })
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            ) : (
              <Box p={4}>
                {paginatedData.length === 0 ? (
                  <Box textAlign="center" py={12}>
                    <Text color="gray.500" fontSize="lg">Aucun personnel trouvé</Text>
                  </Box>
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={4}>
                    {paginatedData.map((row) => {
                      const user = tableData.find(u => u.id === row.id);
                      const fullName = `${row.prenom || ''} ${row.nom || ''}`.trim() || 'N/A';
                      const role = row.rôle || '';
                      const city = row.ville || user?.ville || '---';
                      const status = row.statut || '---';
                      const roleDisplay = role === 'médecin regulateur' || role === 'medecin regulateur' ? 'Médecin régulateur' :
                        role === 'médecin' ? 'Médecin spécialiste' :
                        role === 'infirmier' ? 'Soins Intensifs' :
                          role === 'ambulancier' ? 'Transport médicalisé' : role;

                      return (
                        <Card
                          key={row.id}
                          bg="white"
                          borderRadius="12px"
                          border="1px solid"
                          borderColor="#E5E5E5"
                          p={4}
                          _hover={{
                            boxShadow: '0px 3px 4px 0px rgba(0,0,0,0.03)',
                            transform: 'translateY(-2px)',
                            borderColor: '#459CE9'
                          }}
                          transition="all 0.2s"
                          position="relative"
                          zIndex={1}
                          _focusWithin={{ zIndex: 10 }}
                          cursor="pointer"
                          onClick={() => openDetailPanel(row)}
                        >
                          <VStack align="stretch" spacing={3}>
                            {/* Header avec checkbox et menu */}
                            <Flex justify="space-between" align="start">
                              <Checkbox
                                isChecked={selectedUsers.includes(row.id)}
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => {
                                  setSelectedUsers(prev =>
                                    prev.includes(row.id)
                                      ? prev.filter(id => id !== row.id)
                                      : [...prev, row.id]
                                  );
                                }}
                              />
                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Actions"
                                  onClick={(e) => e.stopPropagation()}
                                />
                                <MenuList zIndex={1000} boxShadow="0px 4px 12px 0px rgba(0,0,0,0.15)">
                                  <MenuItem icon={<MdVisibility />} onClick={(e) => {
                                    e.stopPropagation();
                                    handleView(row.id);
                                  }}>
                                    Voir
                                  </MenuItem>
                                  {hasPermission('utilisateurs_edit') && (
                                    <MenuItem icon={<MdEdit />} onClick={(e) => {
                                      e.stopPropagation();
                                      handleEdit(row.id);
                                    }}>
                                      Modifier
                                    </MenuItem>
                                  )}
                                  <MenuItem icon={<MdLocationOn />} onClick={(e) => {
                                    e.stopPropagation();
                                    openSiteChange(row);
                                  }}>
                                    Changer de Site
                                  </MenuItem>
                                  {hasPermission('utilisateurs_delete') && (
                                    <MenuItem icon={<MdDelete />} onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemove(row.id);
                                    }} color="red.500">
                                      Supprimer
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Flex>

                            {/* Photo et nom */}
                            <Flex align="center" gap={3}>
                              <Avatar
                                size="lg"
                                src={user?.photo || row.photo}
                                name={fullName}
                                borderRadius="12px"
                              />
                              <VStack align="start" spacing={0} flex="1">
                                <Text fontWeight="bold" fontSize="md" noOfLines={1}>
                                  {fullName}
                                </Text>
                                <Text fontSize="xs" color="gray.500" noOfLines={1}>
                                  {roleDisplay}
                                </Text>
                                <Text fontSize="xs" color="gray.400" fontWeight="medium">
                                  P-{String(row.id).padStart(3, '0')}
                                </Text>
                              </VStack>
                            </Flex>

                            <Divider />

                            {/* Informations */}
                            <VStack align="stretch" spacing={2}>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Type</Text>
                                <Text fontSize="sm" fontWeight="medium">
                                  {role.charAt(0).toUpperCase() + role.slice(1)}
                                </Text>
                              </HStack>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Ville</Text>
                                <Text fontSize="sm" fontWeight="medium">{city}</Text>
                              </HStack>
                              <HStack justify="space-between">
                                <Text fontSize="xs" color="gray.500">Site</Text>
                                {userSiteMap[row.id] ? (
                                  <Badge colorScheme="teal" borderRadius="full" px={2} fontSize="xs"
                                    cursor="pointer"
                                    onClick={(e) => { e.stopPropagation(); openSiteChange(row); }}>
                                    📍 {userSiteMap[row.id].SiteName}
                                  </Badge>
                                ) : (
                                  <Text fontSize="xs" color="gray.400">Non assigné</Text>
                                )}
                              </HStack>

                            </VStack>

                            <Divider />

                            {/* Contact et statut */}
                            <VStack align="stretch" spacing={2}>
                              <HStack spacing={2}>
                                <Icon as={MdLocationOn} color="gray.400" w="16px" h="16px" />
                                <Text fontSize="xs" color="gray.600" noOfLines={1}>
                                  {city}
                                </Text>
                              </HStack>
                              <HStack spacing={2}>
                                <Icon as={MdEmail} color="gray.400" w="16px" h="16px" />
                                <Text fontSize="xs" color="gray.600" noOfLines={1}>
                                  {row.email || '---'}
                                </Text>
                              </HStack>
                              {row.téléphone && (
                                <HStack spacing={2}>
                                  <Icon as={MdPhone} color="gray.400" w="16px" h="16px" />
                                  <Text fontSize="xs" color="gray.600" noOfLines={1}>
                                    {row.téléphone}
                                  </Text>
                                </HStack>
                              )}
                              <HStack justify="space-between" pt={2}>
                                <Badge
                                  colorScheme={
                                    status.toLowerCase() === 'actif' ? 'green' :
                                      status.toLowerCase() === 'en mission' ? 'blue' :
                                        status.toLowerCase() === 'en pause' ? 'red' : 'gray'
                                  }
                                  borderRadius="full"
                                  px={3}
                                  py={1}
                                >
                                  • {status}
                                </Badge>
                                <HStack spacing={2}>
                                  <IconButton
                                    icon={<MdVisibility />}
                                    aria-label="Voir"
                                    size="xs"
                                    variant="ghost"
                                    onClick={() => handleView(row.id)}
                                  />
                                  {hasPermission('utilisateurs_edit') && (
                                    <IconButton
                                      icon={<MdEdit />}
                                      aria-label="Modifier"
                                      size="xs"
                                      variant="ghost"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEdit(row.id);
                                      }}
                                    />
                                  )}
                                </HStack>
                              </HStack>
                            </VStack>
                          </VStack>
                        </Card>
                      );
                    })}
                  </SimpleGrid>
                )}
              </Box>
            )}

            {/* Pagination */}
            {paginatedData.length > 0 && (
              <Flex justify="space-between" align="center" p={4} borderTop="1px solid" borderColor="gray.200">
                <HStack spacing={2}>
                  <Text fontSize="sm" color="gray.600">Afficher</Text>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    w="100px"
                    size="sm"
                    bg="white"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Select>
                  <Text fontSize="sm" color="gray.600">par page</Text>
                </HStack>
                <Text fontSize="sm" color="gray.600">
                  {startIndex + 1} à {Math.min(endIndex, filteredData.length)} sur {filteredData.length}
                </Text>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdChevronLeft />}
                    aria-label="Page précédente"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    isDisabled={currentPage === 1}
                  />
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    return (
                      <Button
                        key={pageNum}
                        size="sm"
                        variant={currentPage === pageNum ? "solid" : "outline"}
                        colorScheme={currentPage === pageNum ? "blue" : "gray"}
                        onClick={() => setCurrentPage(pageNum)}
                      >
                        {pageNum}
                      </Button>
                    );
                  })}
                  <IconButton
                    icon={<MdChevronRight />}
                    aria-label="Page suivante"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    isDisabled={currentPage === totalPages}
                  />
                </HStack>
              </Flex>
            )}
          </Box>
        </VStack>
      </Box>

      {/* ===== Modal: Changer de Site ===== */}
      {siteChangeUser && (
        <Modal isOpen={isSiteChangeOpen} onClose={onSiteChangeClose} size="md">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <VStack align="start" spacing={1}>
                <HStack>
                  <MdLocationOn />
                  <Text>Changer de Site</Text>
                </HStack>
                <Text fontSize="sm" fontWeight="normal" color="gray.500">
                  {siteChangeUser.prenom} {siteChangeUser.nom}
                </Text>
              </VStack>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack spacing={4}>
                {userSiteMap[siteChangeUser.id] && (
                  <Box w="full" p={3} bg="teal.50" borderRadius="8px" border="1px solid" borderColor="teal.200">
                    <Text fontSize="xs" color="teal.600" mb={1}>Site actuel</Text>
                    <HStack>
                      <MdLocationOn color="teal" />
                      <Text fontWeight="semibold" color="teal.700">
                        {userSiteMap[siteChangeUser.id].SiteName}
                      </Text>
                    </HStack>
                  </Box>
                )}
                <FormControl>
                  <FormLabel>Nouveau Site</FormLabel>
                  <Select
                    placeholder="Sélectionner un site..."
                    value={selectedSiteId}
                    onChange={(e) => setSelectedSiteId(e.target.value)}
                  >
                    {allSites.map((site) => (
                      <option key={site.SiteID} value={site.SiteID}>
                        {site.SiteName}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <HStack spacing={3} w="full" justify="space-between">
                <Box>
                  {userSiteMap[siteChangeUser.id] && (
                    <Button
                      size="sm"
                      colorScheme="red"
                      variant="ghost"
                      onClick={handleRemoveSite}
                      isLoading={siteChangeLoading}
                    >
                      Retirer du site
                    </Button>
                  )}
                </Box>
                <HStack spacing={2}>
                  <Button variant="ghost" onClick={onSiteChangeClose} isDisabled={siteChangeLoading}>
                    Annuler
                  </Button>
                  <Button
                    colorScheme="blue"
                    onClick={handleChangeSite}
                    isLoading={siteChangeLoading}
                    loadingText="Sauvegarde..."
                    isDisabled={!selectedSiteId}
                  >
                    {userSiteMap[siteChangeUser.id] ? "Changer" : "Assigner"}
                  </Button>
                </HStack>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/* Delete Confirmation */}
      <AlertDialog isOpen={isAlertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirmer la suppression</AlertDialogHeader>
            <AlertDialogBody>Êtes-vous sûr de vouloir supprimer cet utilisateur ?</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>Annuler</Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>Supprimer</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Edit Modal */}
      <Modal isOpen={isEditOpen} onClose={handleCloseEdit} size="xl">
        <ModalOverlay />
        <ModalContent maxW="900px" maxH="90vh" overflowY="auto">
          <ModalHeader>
            <Text fontSize="xl" fontWeight="bold">Modifier le personnel</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editData && (
              <Flex gap={6}>
                {/* Colonne gauche - Photo et compte actif */}
                <Box w="200px" flexShrink={0}>
                  <VStack spacing={4} align="center">
                    {/* Photo de profil */}
                    <Box
                      w="100px"
                      h="100px"
                      borderRadius="full"
                      bg="gray.100"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      border="2px dashed"
                      borderColor="gray.300"
                      overflow="hidden"
                    >
                      {editData.photo ? (
                        <Avatar size="full" src={editData.photo} w="100%" h="100%" />
                      ) : (
                        <Icon as={MdCameraAlt} w="40px" h="40px" color="gray.400" />
                      )}
                    </Box>
                    <VStack spacing={1}>
                      <Text fontSize="sm" fontWeight="medium" color="gray.700">Photo de profil</Text>
                      <Text fontSize="xs" color="gray.500" textAlign="center">
                        Téléchargez une photo de profil.<br />
                      </Text>
                    </VStack>
                    <Input
                      type="file"
                      accept="image/jpeg,image/jpg,image/png,image/gif"
                      onChange={handleEditPhotoUpload}
                      style={{ display: 'none' }}
                      id="photo-upload-edit"
                    />
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => document.getElementById('photo-upload-edit').click()}
                    >
                      Télécharger une photo
                    </Button>

                    {/* Compte actif */}
                    <Box
                      w="full"
                      bg="blue.50"
                      borderRadius="md"
                      p={4}
                      mt={4}
                    >
                      <Flex justify="space-between" align="center">
                        <Box>
                          <Text fontSize="sm" fontWeight="semibold" color="gray.700">Compte actif</Text>

                        </Box>
                        <Switch
                          isChecked={editData.statut === "actif"}
                          onChange={(e) => updateField("statut", e.target.checked ? "actif" : "inactif")}
                          colorScheme="blue"
                          size="lg"
                        />
                      </Flex>
                    </Box>
                  </VStack>
                </Box>

                {/* Colonne droite - Formulaire */}
                <Box flex="1">
                  <VStack spacing={5} align="stretch">
                    <SimpleGrid columns={2} spacing={4}>
                      <FormControl isRequired>
                        <FormLabel fontWeight="semibold">Nom </FormLabel>
                        <Input
                          placeholder="Saisissez Nom"
                          value={editData.nom || ''}
                          onChange={(e) => updateField("nom", e.target.value)}
                        />
                      </FormControl>
                      <FormControl isRequired>
                        <FormLabel fontWeight="semibold">Prénom </FormLabel>
                        <Input
                          placeholder="Saisissez Prénom"
                          value={editData.prenom || ''}
                          onChange={(e) => updateField("prenom", e.target.value)}
                        />
                      </FormControl>
                    </SimpleGrid>

                    {/* Date de naissance */}
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold">Date de naissance </FormLabel>
                      <Input
                        type="date"
                        value={editData.date_naissance || ''}
                        onChange={(e) => updateField("date_naissance", e.target.value)}
                      />
                    </FormControl>

                    {/* Ville */}
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold">Ville </FormLabel>
                      <Select
                        placeholder="Sélectionner la Ville..."
                        value={editData.ville || ''}
                        onChange={(e) => updateField("ville", e.target.value)}
                      >
                        {villesMaroc.map((ville) => (
                          <option key={ville} value={ville}>{ville}</option>
                        ))}
                      </Select>
                    </FormControl>

                    <Divider />

                    {/* Rôle */}
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold" mb={3}>Rôle </FormLabel>
                      <RadioGroup
                        value={editData.rôle || ''}
                        onChange={(value) => updateField("rôle", value)}
                      >
                        <Stack direction="row" spacing={4} flexWrap="wrap">
                          <Radio value="infirmier">Infirmière</Radio>
                          <Radio value="médecin">Médecin</Radio>
                          <Radio value="médecin regulateur">Médecin régulateur</Radio>
                          <Radio value="ambulancier">Ambulancier</Radio>
                          <Radio value="régulateur">Régulateur</Radio>
                          <Radio value="admin">Admin</Radio>
                        </Stack>
                      </RadioGroup>
                    </FormControl>

                    {/* Genre */}
                    <FormControl isRequired>
                      <FormLabel fontWeight="semibold" mb={3}>Genre </FormLabel>
                      <RadioGroup
                        value={editData.genre || ''}
                        onChange={(value) => updateField("genre", value)}
                      >
                        <Stack direction="row" spacing={4}>
                          <Radio value="homme">Homme</Radio>
                          <Radio value="femme">Femme</Radio>
                        </Stack>
                      </RadioGroup>
                    </FormControl>

                    <Divider />

                    {/* Informations de connexion */}
                    <Box>
                      <Text fontSize="md" fontWeight="semibold" mb={1}>Informations de connexion </Text>
                      <Text fontSize="sm" color="gray.500" mb={4}>
                        L'utilisateur peut accéder à la plateforme et effectuer ses tâches
                      </Text>
                    </Box>

                    {/* E-mail et Téléphone sur la même ligne */}
                    <SimpleGrid columns={2} spacing={4}>
                      <FormControl isRequired>
                        <FormLabel fontWeight="semibold">E-mail </FormLabel>
                        <Input
                          type="email"
                          placeholder="Saisissez E-mail"
                          value={editData.email || ''}
                          onChange={(e) => updateField("email", e.target.value)}
                        />
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel fontWeight="semibold">Téléphone </FormLabel>
                        <InputGroup>
                          <InputLeftAddon bg="gray.50" borderRight="none">
                            <HStack spacing={1}>
                              <Box w="20px" h="14px" bg="red.500" borderRadius="2px" />
                              <Text fontSize="sm" fontWeight="medium">+212</Text>
                            </HStack>
                          </InputLeftAddon>
                          <Input
                            placeholder="Saisissez numéro de téléphone..."
                            value={editData.téléphone || ''}
                            onChange={(e) => updateField("téléphone", e.target.value)}
                            borderLeftRadius="0"
                          />
                        </InputGroup>
                      </FormControl>
                    </SimpleGrid>

                    <Divider />

                    {/* Section Permissions */}
                    <Box>
                      <FormLabel fontWeight="semibold" mb={3}>Permissions</FormLabel>
                      <VStack spacing={3} align="stretch">
                        {permissionsConfig.map((config) => (
                          <Box key={config.page} bg="gray.50" p={3} borderRadius="md">
                            <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={2}>
                              {config.label}
                            </Text>
                            <HStack spacing={4} flexWrap="wrap">
                              {config.perms.map((perm) => {
                                const permKey = `${config.page}_${perm}`;
                                return (
                                  <Checkbox
                                    key={permKey}
                                    isChecked={(editData.perm || []).includes(permKey)}
                                    onChange={(e) => {
                                      const currentPerms = editData.perm || [];
                                      if (e.target.checked) {
                                        updatePermissions([...currentPerms, permKey]);
                                      } else {
                                        updatePermissions(currentPerms.filter(p => p !== permKey));
                                      }
                                    }}
                                    colorScheme="blue"
                                    size="sm"
                                  >
                                    <Text fontSize="xs" fontWeight="medium">
                                      {permLabels[perm]}
                                    </Text>
                                  </Checkbox>
                                );
                              })}
                            </HStack>
                          </Box>
                        ))}
                        {/* Option accès complet */}
                        <Box bg="blue.50" p={3} borderRadius="md" border="1px solid" borderColor="blue.200">
                          <Checkbox
                            isChecked={(editData.perm || []).includes("allaccess")}
                            onChange={(e) => {
                              const currentPerms = editData.perm || [];
                              if (e.target.checked) {
                                updatePermissions([...currentPerms, "allaccess"]);
                              } else {
                                updatePermissions(currentPerms.filter(p => p !== "allaccess"));
                              }
                            }}
                            colorScheme="blue"
                          >
                            <Text fontSize="sm" fontWeight="semibold" color="blue.700">
                              Accès complet (toutes les permissions)
                            </Text>
                          </Checkbox>
                        </Box>
                      </VStack>
                    </Box>
                  </VStack>
                </Box>
              </Flex>
            )}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.200" mt={4}>
            <Button variant="ghost" mr={3} onClick={handleCloseEdit}>
              Annuler
            </Button>
            <Button colorScheme="blue" onClick={handleSave}>
              Sauvegarder
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Add Modal */}
      <Modal isOpen={isAddOpen} onClose={() => { onAddClose(); resetAddForm(); }} size="xl">
        <ModalOverlay />
        <ModalContent maxW="600px" maxH="90vh" overflowY="auto">
          <ModalHeader>
            <Text fontSize="xl" fontWeight="bold">Créer une personnel</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={6} align="stretch">
              {/* Photo de profil */}
              <FormControl>
                <FormLabel fontWeight="semibold" mb={3}>Photo de profil</FormLabel>
                <Center>
                  <VStack spacing={3}>
                    {photoPreview ? (
                      <Avatar size="xl" src={photoPreview} />
                    ) : (
                      <Box
                        w="100px"
                        h="100px"
                        borderRadius="full"
                        bg="gray.100"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        border="2px dashed"
                        borderColor="gray.300"
                      >
                        <Icon as={MdCameraAlt} w="40px" h="40px" color="gray.400" />
                      </Box>
                    )}
                    <VStack spacing={1}>
                      <Text fontSize="xs" color="gray.500" textAlign="center">
                        JPG, PNG ou GIF. 2 Mo maximum.
                      </Text>
                    </VStack>
                    <Input
                      type="file"
                      accept="image/jpeg,image/jpg,image/png,image/gif"
                      onChange={handlePhotoUpload}
                      style={{ display: 'none' }}
                      id="photo-upload-add"
                    />
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => document.getElementById('photo-upload-add').click()}
                    >
                      Télécharger une photo
                    </Button>
                  </VStack>
                </Center>
              </FormControl>

              <Divider />

              <SimpleGrid columns={2} spacing={4}>
                <FormControl isRequired>
                  <FormLabel fontWeight="semibold">Nom</FormLabel>
                  <Input
                    placeholder="Nom"
                    value={newUserData.nom}
                    onChange={(e) => updateAddField("nom", e.target.value)}
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel fontWeight="semibold">Prénom</FormLabel>
                  <Input
                    placeholder="Prénom"
                    value={newUserData.prenom}
                    onChange={(e) => updateAddField("prenom", e.target.value)}
                  />
                </FormControl>
              </SimpleGrid>

              {/* Date de naissance */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold">Date de naissance</FormLabel>
                <Input
                  type="date"
                  value={newUserData.date_naissance}
                  onChange={(e) => updateAddField("date_naissance", e.target.value)}
                />
              </FormControl>

              {/* Ville */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold">Ville</FormLabel>
                <Select
                  placeholder="Sélectionner la Ville..."
                  value={newUserData.ville}
                  onChange={(e) => updateAddField("ville", e.target.value)}
                >
                  {villesMaroc.map((ville) => (
                    <option key={ville} value={ville}>{ville}</option>
                  ))}
                </Select>
              </FormControl>

              {/* Compte actif */}
              <FormControl>
                <Flex justify="space-between" align="center">
                  <Box>
                    <FormLabel fontWeight="semibold" mb={1}>Compte actif</FormLabel>
                    <Text fontSize="sm" color="gray.500">
                      L'utilisateur peut accéder à la plateforme et effectuer ses tâches.
                    </Text>
                  </Box>
                  <Switch
                    isChecked={newUserData.compte_actif}
                    onChange={(e) => updateAddField("compte_actif", e.target.checked)}
                    colorScheme="blue"
                    size="lg"
                  />
                </Flex>
              </FormControl>

              <Divider />

              {/* Rôle */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold" mb={3}>Rôle</FormLabel>
                <RadioGroup
                  value={newUserData.rôle}
                  onChange={(value) => updateAddField("rôle", value)}
                >
                  <Stack direction="row" spacing={4} flexWrap="wrap">
                    <Radio value="infirmier">Infirmière</Radio>
                    <Radio value="médecin">Médecin</Radio>
                    <Radio value="médecin regulateur">Médecin régulateur</Radio>
                    <Radio value="ambulancier">Ambulancier</Radio>
                    <Radio value="régulateur">Régulateur</Radio>
                    <Radio value="admin">Admin</Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>

              {/* Genre */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold" mb={3}>Genre</FormLabel>
                <RadioGroup
                  value={newUserData.genre}
                  onChange={(value) => updateAddField("genre", value)}
                >
                  <Stack direction="row" spacing={4}>
                    <Radio value="homme">Homme</Radio>
                    <Radio value="femme">Femme</Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>

              <Divider />

              {/* Informations de connexion */}
              <Box>
                <Text fontSize="sm" color="gray.500" mb={4}>
                  L'utilisateur peut accéder à la plateforme et effectuer ses tâches.
                </Text>
              </Box>

              {/* E-mail */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold">E-mail</FormLabel>
                <Input
                  type="email"
                  placeholder="Saisissez E-mail"
                  value={newUserData.email}
                  onChange={(e) => updateAddField("email", e.target.value)}
                />
              </FormControl>

              {/* Téléphone */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold">Téléphone</FormLabel>
                <InputGroup>
                  <InputLeftAddon bg="gray.50" borderRight="none">
                    <Text fontSize="sm" fontWeight="medium">+212</Text>
                  </InputLeftAddon>
                  <Input
                    placeholder="Saisissez numéro de téléphone..."
                    value={newUserData.téléphone}
                    onChange={(e) => updateAddField("téléphone", e.target.value)}
                    borderLeftRadius="0"
                  />
                </InputGroup>
              </FormControl>

              {/* Mot de passe */}
              <FormControl isRequired>
                <FormLabel fontWeight="semibold">Mot de passe</FormLabel>
                <InputGroup>
                  <Input
                    type="text"
                    value={newUserData.mot_de_passe}
                    onChange={(e) => updateAddField("mot_de_passe", e.target.value)}
                    bg="gray.50"
                  />
                  <InputRightAddon p={0}>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={copyPassword}
                      leftIcon={<Icon as={MdContentCopy} />}
                    >
                      Copie
                    </Button>
                  </InputRightAddon>
                </InputGroup>
              </FormControl>

              <Divider />

              {/* Section Permissions */}
              <Box>
                <FormLabel fontWeight="semibold" mb={3}>Permissions</FormLabel>
                <VStack spacing={3} align="stretch">
                  {permissionsConfig.map((config) => (
                    <Box key={config.page} bg="gray.50" p={3} borderRadius="md">
                      <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={2}>
                        {config.label}
                      </Text>
                      <HStack spacing={4} flexWrap="wrap">
                        {config.perms.map((perm) => {
                          const permKey = `${config.page}_${perm}`;
                          return (
                            <Checkbox
                              key={permKey}
                              isChecked={(newUserData.perm || []).includes(permKey)}
                              onChange={(e) => {
                                const currentPerms = newUserData.perm || [];
                                if (e.target.checked) {
                                  updateAddPermissions([...currentPerms, permKey]);
                                } else {
                                  updateAddPermissions(currentPerms.filter(p => p !== permKey));
                                }
                              }}
                              colorScheme="blue"
                              size="sm"
                            >
                              <Text fontSize="xs" fontWeight="medium">
                                {permLabels[perm]}
                              </Text>
                            </Checkbox>
                          );
                        })}
                      </HStack>
                    </Box>
                  ))}
                  {/* Option accès complet */}
                  <Box bg="blue.50" p={3} borderRadius="md" border="1px solid" borderColor="blue.200">
                    <Checkbox
                      isChecked={(newUserData.perm || []).includes("allaccess")}
                      onChange={(e) => {
                        const currentPerms = newUserData.perm || [];
                        if (e.target.checked) {
                          updateAddPermissions([...currentPerms, "allaccess"]);
                        } else {
                          updateAddPermissions(currentPerms.filter(p => p !== "allaccess"));
                        }
                      }}
                      colorScheme="blue"
                    >
                      <Text fontSize="sm" fontWeight="semibold" color="blue.700">
                        Accès complet (toutes les permissions)
                      </Text>
                    </Checkbox>
                  </Box>
                </VStack>
              </Box>

              <Divider />

            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={() => { onAddClose(); resetAddForm(); }}>
              Annuler
            </Button>
            <Button colorScheme="blue" onClick={handleAdd}>
              Ajouter
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Modal - Full Profile */}
      <Modal isOpen={isViewOpen} onClose={onViewClose} size="6xl">
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent
          maxW="1400px"
          maxH="90vh"
          overflowY="auto"
          borderRadius="12px"
        >
          {viewData && (
            <>
              {/* Header avec breadcrumbs et bouton retour */}
              <Box bg="white" px={6} py={4} borderBottom="1px solid" borderColor="gray.200" borderTopRadius="12px">
                <Breadcrumb fontSize="sm" mb={2}>
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#" color="gray.600">Gestion des utilisateurs</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#" color="gray.600">Utilisateurs</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink color="gray.900" fontWeight="medium">Profil du Staff</BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
                <Flex align="center" gap={3}>
                  <IconButton
                    icon={<Icon as={MdArrowBack} />}
                    aria-label="Retour"
                    variant="ghost"
                    size="sm"
                    onClick={onViewClose}
                  />
                  <Heading size="lg">Profil du Staff</Heading>
                </Flex>
                <ModalCloseButton top={4} right={4} borderRadius="full" _hover={{ bg: 'gray.100' }} />
              </Box>

              <ModalBody p={6}>
                <Flex gap={6} direction={{ base: "column", lg: "row" }}>
                  {/* Colonne gauche - Carte de profil */}
                  <Box flex="0 0 350px">
                    <Card bg="white" borderRadius="12px" p={6} border="1px solid" borderColor="gray.200">
                      <VStack spacing={4} align="stretch">
                        {/* Photo de profil */}
                        <Center>
                          <Avatar
                            size="2xl"
                            src={viewData.photo || "https://img.freepik.com/vecteurs-premium/icones-utilisateur-comprend-icones-utilisateur-symboles-icones-personnes-elements-conception-graphique-qualite-superieure_981536-526.jpg"}
                            name={`${viewData.prenom || ''} ${viewData.nom || ''}`}
                          />
                        </Center>

                        {/* ID et nom */}
                        <VStack spacing={1} align="center">
                          <Text fontSize="xs" color="gray.500" fontWeight="medium">
                            #P-{String(viewData.id).padStart(3, '0')}
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="gray.900" textAlign="center">
                            {viewData.prenom || ''} {viewData.nom || ''}
                          </Text>
                          <Text fontSize="sm" color="gray.600" textAlign="center">
                            {viewData.rôle === 'médecin' ? 'Médecin' :
                              viewData.rôle === 'infirmier' ? 'Infirmière' :
                                viewData.rôle?.charAt(0).toUpperCase() + viewData.rôle?.slice(1) || ''} {viewData.specialty || ''}
                          </Text>
                        </VStack>

                        {/* Boutons d'action */}
                        <VStack spacing={3} w="full">
                          <Button
                            leftIcon={<Icon as={MdCall} />}
                            colorScheme="teal"
                            w="full"
                            onClick={() => window.location.href = `tel:${viewData.téléphone}`}
                          >
                            Appelle-la
                          </Button>
                          <Button
                            leftIcon={<Icon as={MdEmail} />}
                            colorScheme="blue"
                            w="full"
                            onClick={() => window.location.href = `mailto:${viewData.email}`}
                          >
                            Envoyer un mail
                          </Button>
                        </VStack>

                        <Divider />

                        {/* Grille d'informations */}
                        <SimpleGrid columns={2} spacing={4}>
                          <VStack align="start" spacing={1}>
                            <Text fontSize="xs" color="gray.500">Ville</Text>
                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                              {viewData.ville || '---'}
                            </Text>
                          </VStack>
                          <VStack align="start" spacing={1}>
                            <Text fontSize="xs" color="gray.500">Disponibles Actuelle</Text>
                            <Badge
                              colorScheme={
                                viewData.statut?.toLowerCase() === 'actif' ? 'green' :
                                  viewData.statut?.toLowerCase() === 'en mission' ? 'blue' :
                                    viewData.statut?.toLowerCase() === 'en pause' ? 'red' : 'gray'
                              }
                              borderRadius="full"
                            >
                              {viewData.statut || '---'}
                            </Badge>
                          </VStack>
                          <VStack align="start" spacing={1}>
                            <Text fontSize="xs" color="gray.500">Dernière mission</Text>
                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                              {viewData.derniere_mission ? new Date(viewData.derniere_mission).toLocaleDateString("fr-FR") : '---'}
                            </Text>
                          </VStack>
                          <VStack align="start" spacing={1}>
                            <Text fontSize="xs" color="gray.500">Date de naissance</Text>
                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                              {viewData.date_naissance ? new Date(viewData.date_naissance).toLocaleDateString("fr-FR") : '---'}
                            </Text>
                          </VStack>
                          <VStack align="start" spacing={1}>
                            <Text fontSize="xs" color="gray.500">Genre</Text>
                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                              {viewData.genre === 'homme' ? 'Homme' : viewData.genre === 'femme' ? 'Femme' : viewData.genre || '---'}
                            </Text>
                          </VStack>
                          <VStack align="start" spacing={1} colSpan={2}>
                            <Text fontSize="xs" color="gray.500">Type</Text>
                            <Text fontSize="sm" fontWeight="medium" color="gray.900">
                              {viewData.rôle?.charAt(0).toUpperCase() + viewData.rôle?.slice(1) || '---'}
                            </Text>
                          </VStack>
                        </SimpleGrid>
                      </VStack>
                    </Card>
                  </Box>

                  {/* Colonne droite - Onglets */}
                  <Box flex="1">
                    <Tabs colorScheme="blue">
                      <TabList>
                        <Tab>Aperçu</Tab>
                        <Tab>Missions <Badge ml={2} colorScheme="blue">{userMissions.length}</Badge></Tab>
                        <Tab>Performance</Tab>
                      </TabList>

                      <TabPanels>
                        {/* Onglet Aperçu */}
                        <TabPanel px={0} pt={6}>
                          <VStack spacing={6} align="stretch">
                            {/* Section À Propos */}
                            <Box>
                              <Text fontSize="lg" fontWeight="bold" color="gray.900" mb={3}>
                                À Propos
                              </Text>
                              <Text fontSize="sm" color="gray.600" lineHeight="1.7">
                                {viewData.à_propos ||
                                  `${viewData.rôle === 'médecin' ? 'Médecin' : viewData.rôle === 'infirmier' ? 'Infirmière' : viewData.rôle || ''} ${viewData.specialty || ''} avec plusieurs années d'expérience. Disponible pour les visites à domicile et téléconsultations.`}
                              </Text>
                            </Box>

                            <Divider />

                            {/* Section Coordonnées */}
                            <Box>
                              <Text fontSize="lg" fontWeight="bold" color="gray.900" mb={3}>
                                Coordonnées
                              </Text>
                              <VStack spacing={3} align="stretch">
                                {viewData.téléphone && (
                                  <HStack spacing={3}>
                                    <Icon as={MdPhone} color="gray.400" w="20px" h="20px" />
                                    <Text fontSize="sm" color="gray.600">
                                      {viewData.téléphone}
                                    </Text>
                                  </HStack>
                                )}
                                {viewData.email && (
                                  <HStack spacing={3}>
                                    <Icon as={MdEmail} color="gray.400" w="20px" h="20px" />
                                    <Text fontSize="sm" color="gray.600">
                                      {viewData.email}
                                    </Text>
                                  </HStack>
                                )}
                              </VStack>
                            </Box>
                          </VStack>
                        </TabPanel>

                        {/* Onglet Missions */}
                        <TabPanel px={0} pt={6}>
                          <VStack spacing={4} align="stretch">
                            {/* Header avec titre */}
                            <Text fontSize="lg" fontWeight="bold" color="gray.900">
                              Liste des missions
                            </Text>

                            {/* Barre de recherche et filtres */}
                            <Flex gap={4} align="center" flexWrap="wrap">
                              <InputGroup maxW="400px" flex="1" minW="250px">
                                <InputLeftElement pointerEvents="none">
                                  <Icon as={MdSearch} color="gray.400" />
                                </InputLeftElement>
                                <Input
                                  placeholder="Recherche d'une mission..."
                                  value={missionSearchQuery}
                                  onChange={(e) => {
                                    setMissionSearchQuery(e.target.value);
                                    setMissionCurrentPage(1);
                                  }}
                                  bg="white"
                                  borderRadius="md"
                                />
                              </InputGroup>
                              <Select
                                value={missionStatusFilter}
                                onChange={(e) => {
                                  setMissionStatusFilter(e.target.value);
                                  setMissionCurrentPage(1);
                                }}
                                maxW="200px"
                                size="sm"
                                bg="white"
                              >
                                <option value="all">Statut: Tous</option>
                                <option value="terminée">Terminée</option>
                                <option value="en cours">En cours</option>
                                <option value="planifiée">Planifiée</option>
                                <option value="annulée">Annulée</option>
                              </Select>
                              <Button
                                size="sm"
                                variant="outline"
                                leftIcon={<Icon as={MdArrowDownward} />}
                              >
                                Export
                              </Button>
                            </Flex>

                            {/* Tableau des missions */}
                            <Box bg="white" borderRadius="12px" border="1px solid" borderColor="gray.200" overflow="hidden">
                              <TableContainer>
                                <Table variant="simple">
                                  <Thead bg="gray.50">
                                    <Tr>
                                      <Th>Réf</Th>
                                      <Th>Patient</Th>
                                      <Th>Type Ambulance</Th>
                                      <Th>Type Mission</Th>
                                      <Th>État d'Urgence</Th>
                                      <Th>Date de création</Th>
                                      <Th>Date de mission</Th>
                                      <Th></Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {(() => {
                                      // Filtrer les missions
                                      let filteredMissions = userMissions;

                                      if (missionSearchQuery) {
                                        filteredMissions = filteredMissions.filter(mission => {
                                          const searchFields = [
                                            mission.ref || '',
                                            mission.patient?.nom || '',
                                            mission.patient?.prenom || '',
                                            mission.patient?.téléphone || '',
                                            mission.type_mission || '',
                                            mission.type_ambulance || '',
                                          ];
                                          return searchFields.some(field =>
                                            field && field.toLowerCase().includes(missionSearchQuery.toLowerCase())
                                          );
                                        });
                                      }

                                      if (missionStatusFilter !== "all") {
                                        filteredMissions = filteredMissions.filter(mission => {
                                          const statut = (mission.statut || '').toLowerCase();
                                          return statut === missionStatusFilter.toLowerCase();
                                        });
                                      }

                                      // Pagination
                                      const missionStartIndex = (missionCurrentPage - 1) * missionItemsPerPage;
                                      const missionEndIndex = missionStartIndex + missionItemsPerPage;
                                      const paginatedMissions = filteredMissions.slice(missionStartIndex, missionEndIndex);
                                      const missionTotalPages = Math.ceil(filteredMissions.length / missionItemsPerPage);

                                      return (
                                        <>
                                          {paginatedMissions.length === 0 ? (
                                            <Tr>
                                              <Td colSpan={8} textAlign="center" py={8}>
                                                <Text color="gray.500">Aucune mission trouvée</Text>
                                              </Td>
                                            </Tr>
                                          ) : (
                                            paginatedMissions.map((mission) => {
                                              const urgencyColor =
                                                mission.urgence === 'urgente' || mission.urgence === 'Urgente' ? 'red' :
                                                  mission.urgence === 'planifiée' || mission.urgence === 'Planifiée' ? 'blue' :
                                                    mission.urgence === 'moyenne' || mission.urgence === 'Moyenne' ? 'yellow' :
                                                      'gray';

                                              return (
                                                <Tr key={mission.id} _hover={{ bg: "gray.50" }}>
                                                  <Td fontWeight="medium">REF-{String(mission.id).padStart(3, '0')}</Td>
                                                  <Td>
                                                    <HStack spacing={2}>
                                                      <Avatar
                                                        size="sm"
                                                        src={mission.patient?.photo}
                                                        name={`${mission.patient?.prenom || ''} ${mission.patient?.nom || ''}`}
                                                      />
                                                      <VStack align="start" spacing={0}>
                                                        <Text fontSize="sm" fontWeight="medium">
                                                          {mission.patient?.prenom || ''} {mission.patient?.nom || ''}
                                                        </Text>
                                                        <Text fontSize="xs" color="gray.500">
                                                          {mission.patient?.téléphone || '---'}
                                                        </Text>
                                                      </VStack>
                                                    </HStack>
                                                  </Td>
                                                  <Td>{mission.type_ambulance || '---'}</Td>
                                                  <Td>{mission.type_mission || '---'}</Td>
                                                  <Td>
                                                    <Badge
                                                      colorScheme={urgencyColor}
                                                      borderRadius="full"
                                                    >
                                                      • {mission.urgence || 'Normale'}
                                                    </Badge>
                                                  </Td>
                                                  <Td>
                                                    {mission.date_creation ? new Date(mission.date_creation).toLocaleDateString("fr-FR", {
                                                      day: '2-digit',
                                                      month: '2-digit',
                                                      year: 'numeric',
                                                      hour: '2-digit',
                                                      minute: '2-digit'
                                                    }) : '---'}
                                                  </Td>
                                                  <Td>
                                                    {mission.date_mission ? new Date(mission.date_mission).toLocaleDateString("fr-FR", {
                                                      day: '2-digit',
                                                      month: '2-digit',
                                                      year: 'numeric',
                                                      hour: '2-digit',
                                                      minute: '2-digit'
                                                    }) : '---'}
                                                  </Td>
                                                  <Td>
                                                    <Menu>
                                                      <MenuButton
                                                        as={IconButton}
                                                        icon={<MdMoreVert />}
                                                        variant="ghost"
                                                        size="sm"
                                                        aria-label="Actions"
                                                      />
                                                      <MenuList>
                                                        <MenuItem icon={<MdVisibility />}>
                                                          Voir
                                                        </MenuItem>
                                                        <MenuItem icon={<MdEdit />}>
                                                          Modifier
                                                        </MenuItem>
                                                      </MenuList>
                                                    </Menu>
                                                  </Td>
                                                </Tr>
                                              );
                                            })
                                          )}

                                          {/* Pagination */}
                                          {filteredMissions.length > 0 && (
                                            <Tr>
                                              <Td colSpan={8} borderTop="1px solid" borderColor="gray.200">
                                                <Flex justify="space-between" align="center" p={4}>
                                                  <HStack spacing={2}>
                                                    <Text fontSize="sm" color="gray.600">Afficher</Text>
                                                    <Select
                                                      value={missionItemsPerPage}
                                                      onChange={(e) => {
                                                        setMissionItemsPerPage(Number(e.target.value));
                                                        setMissionCurrentPage(1);
                                                      }}
                                                      w="100px"
                                                      size="sm"
                                                      bg="white"
                                                    >
                                                      <option value={10}>10</option>
                                                      <option value={20}>20</option>
                                                      <option value={50}>50</option>
                                                      <option value={100}>100</option>
                                                    </Select>
                                                    <Text fontSize="sm" color="gray.600">par page</Text>
                                                  </HStack>
                                                  <Text fontSize="sm" color="gray.600">
                                                    {missionStartIndex + 1} à {Math.min(missionEndIndex, filteredMissions.length)} sur {filteredMissions.length}
                                                  </Text>
                                                  <HStack spacing={2}>
                                                    <IconButton
                                                      icon={<MdChevronLeft />}
                                                      aria-label="Page précédente"
                                                      size="sm"
                                                      onClick={() => setMissionCurrentPage(prev => Math.max(1, prev - 1))}
                                                      isDisabled={missionCurrentPage === 1}
                                                    />
                                                    {Array.from({ length: Math.min(5, missionTotalPages) }, (_, i) => {
                                                      let pageNum;
                                                      if (missionTotalPages <= 5) {
                                                        pageNum = i + 1;
                                                      } else if (missionCurrentPage <= 3) {
                                                        pageNum = i + 1;
                                                      } else if (missionCurrentPage >= missionTotalPages - 2) {
                                                        pageNum = missionTotalPages - 4 + i;
                                                      } else {
                                                        pageNum = missionCurrentPage - 2 + i;
                                                      }
                                                      return (
                                                        <Button
                                                          key={pageNum}
                                                          size="sm"
                                                          variant={missionCurrentPage === pageNum ? "solid" : "outline"}
                                                          colorScheme={missionCurrentPage === pageNum ? "blue" : "gray"}
                                                          onClick={() => setMissionCurrentPage(pageNum)}
                                                        >
                                                          {pageNum}
                                                        </Button>
                                                      );
                                                    })}
                                                    <IconButton
                                                      icon={<MdChevronRight />}
                                                      aria-label="Page suivante"
                                                      size="sm"
                                                      onClick={() => setMissionCurrentPage(prev => Math.min(missionTotalPages, prev + 1))}
                                                      isDisabled={missionCurrentPage === missionTotalPages}
                                                    />
                                                  </HStack>
                                                </Flex>
                                              </Td>
                                            </Tr>
                                          )}
                                        </>
                                      );
                                    })()}
                                  </Tbody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </VStack>
                        </TabPanel>


                        {/* Onglet Performance */}
                        <TabPanel px={0} pt={6}>
                          {loadingPerformance ? (
                            <Center py={10}>
                              <LoadingSpinner />
                            </Center>
                          ) : userPerformance ? (
                            <VStack spacing={6} align="stretch">
                              {/* Score global */}
                              <Card bg="white" borderRadius="12px" p={6} border="1px solid" borderColor="gray.200">
                                <VStack spacing={4}>
                                  <Text fontSize="lg" fontWeight="bold" color="gray.900">
                                    Performance Globale
                                  </Text>
                                  <Box position="relative" w="120px" h="120px">
                                    <Center
                                      w="full"
                                      h="full"
                                      borderRadius="full"
                                      bg={
                                        userPerformance.etoile_globale >= 4 ? "green.100" :
                                          userPerformance.etoile_globale >= 3 ? "yellow.100" :
                                            userPerformance.etoile_globale >= 2 ? "orange.100" : "red.100"
                                      }
                                      border="4px solid"
                                      borderColor={
                                        userPerformance.etoile_globale >= 4 ? "green.500" :
                                          userPerformance.etoile_globale >= 3 ? "yellow.500" :
                                            userPerformance.etoile_globale >= 2 ? "orange.500" : "red.500"
                                      }
                                    >
                                      <VStack spacing={1}>
                                        <Text fontSize="3xl" fontWeight="bold" color="gray.900">
                                          {userPerformance.etoile_globale}
                                        </Text>
                                        <Text fontSize="sm" color="gray.500">/5</Text>
                                      </VStack>
                                    </Center>
                                  </Box>
                                  <HStack spacing={1}>
                                    {[1, 2, 3, 4, 5].map((star) => (
                                      <Icon
                                        key={star}
                                        as={star <= Math.round(userPerformance.etoile_globale) ? MdStar : MdStarOutline}
                                        color={star <= Math.round(userPerformance.etoile_globale) ? "yellow.400" : "gray.300"}
                                        w={6}
                                        h={6}
                                      />
                                    ))}
                                  </HStack>
                                  <Text fontSize="sm" color="gray.500">
                                    {userPerformance.nombre_missions} missions effectuées
                                  </Text>
                                </VStack>
                              </Card>

                              {/* Métriques détaillées */}
                              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                                {/* Temps de réactivité */}
                                <Card bg="white" borderRadius="12px" p={5} border="1px solid" borderColor="gray.200">
                                  <VStack spacing={3} align="stretch">
                                    <HStack>
                                      <Center w="40px" h="40px" borderRadius="lg" bg="blue.100">
                                        <Icon as={MdSpeed} color="blue.500" w={5} h={5} />
                                      </Center>
                                      <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                                        Temps de Réactivité
                                      </Text>
                                    </HStack>
                                    <VStack spacing={1} align="start">
                                      <Text fontSize="xl" fontWeight="bold" color="gray.900">
                                        {Math.floor(parseFloat(userPerformance.temps_reactivite.moyenne_secondes) / 60)} min
                                      </Text>
                                      <Text fontSize="xs" color="gray.500">
                                        Moyenne: {parseFloat(userPerformance.temps_reactivite.moyenne_secondes).toFixed(0)} secondes
                                      </Text>
                                    </VStack>
                                    <HStack spacing={0.5}>
                                      {[1, 2, 3, 4, 5].map((star) => (
                                        <Icon
                                          key={star}
                                          as={star <= userPerformance.temps_reactivite.etoiles ? MdStar : MdStarOutline}
                                          color={star <= userPerformance.temps_reactivite.etoiles ? "yellow.400" : "gray.300"}
                                          w={4}
                                          h={4}
                                        />
                                      ))}
                                      <Text fontSize="xs" color="gray.500" ml={1}>
                                        ({userPerformance.temps_reactivite.etoiles}/5)
                                      </Text>
                                    </HStack>
                                  </VStack>
                                </Card>

                                {/* Respect des délais */}
                                <Card bg="white" borderRadius="12px" p={5} border="1px solid" borderColor="gray.200">
                                  <VStack spacing={3} align="stretch">
                                    <HStack>
                                      <Center w="40px" h="40px" borderRadius="lg" bg="green.100">
                                        <Icon as={MdAccessTime} color="green.500" w={5} h={5} />
                                      </Center>
                                      <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                                        Respect des Délais
                                      </Text>
                                    </HStack>
                                    <VStack spacing={1} align="start">
                                      <Text fontSize="xl" fontWeight="bold" color="gray.900">
                                        {parseFloat(userPerformance.respect_delais_intervention.moyenne_secondes).toFixed(0)} sec
                                      </Text>
                                      <Text fontSize="xs" color="gray.500">
                                        Temps d'intervention moyen
                                      </Text>
                                    </VStack>
                                    <HStack spacing={0.5}>
                                      {[1, 2, 3, 4, 5].map((star) => (
                                        <Icon
                                          key={star}
                                          as={star <= userPerformance.respect_delais_intervention.etoiles ? MdStar : MdStarOutline}
                                          color={star <= userPerformance.respect_delais_intervention.etoiles ? "yellow.400" : "gray.300"}
                                          w={4}
                                          h={4}
                                        />
                                      ))}
                                      <Text fontSize="xs" color="gray.500" ml={1}>
                                        ({userPerformance.respect_delais_intervention.etoiles}/5)
                                      </Text>
                                    </HStack>
                                  </VStack>
                                </Card>

                                {/* Satisfaction patient */}
                                <Card bg="white" borderRadius="12px" p={5} border="1px solid" borderColor="gray.200">
                                  <VStack spacing={3} align="stretch">
                                    <HStack>
                                      <Center w="40px" h="40px" borderRadius="lg" bg="purple.100">
                                        <Icon as={MdThumbUp} color="purple.500" w={5} h={5} />
                                      </Center>
                                      <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                                        Satisfaction Patient
                                      </Text>
                                    </HStack>
                                    <VStack spacing={1} align="start">
                                      <Text fontSize="xl" fontWeight="bold" color="gray.900">
                                        {userPerformance.satisfaction_patient.moyenne_etoiles}/5
                                      </Text>
                                      <Text fontSize="xs" color="gray.500">
                                        Basé sur {userPerformance.satisfaction_patient.nombre_avis} avis
                                      </Text>
                                    </VStack>
                                    <HStack spacing={0.5}>
                                      {[1, 2, 3, 4, 5].map((star) => (
                                        <Icon
                                          key={star}
                                          as={star <= userPerformance.satisfaction_patient.etoiles ? MdStar : MdStarOutline}
                                          color={star <= userPerformance.satisfaction_patient.etoiles ? "yellow.400" : "gray.300"}
                                          w={4}
                                          h={4}
                                        />
                                      ))}
                                      <Text fontSize="xs" color="gray.500" ml={1}>
                                        ({userPerformance.satisfaction_patient.etoiles}/5)
                                      </Text>
                                    </HStack>
                                  </VStack>
                                </Card>
                              </SimpleGrid>
                            </VStack>
                          ) : (
                            <Center py={10}>
                              <VStack spacing={3}>
                                <Icon as={MdStarOutline} w={12} h={12} color="gray.300" />
                                <Text color="gray.500">Aucune donnée de performance disponible</Text>
                              </VStack>
                            </Center>
                          )}
                        </TabPanel>

                      </TabPanels>
                    </Tabs>
                  </Box>
                </Flex>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* Detail Panel */}
      {isDetailPanelOpen && selectedUserDetail && (
        <Box
          position="fixed"
          right={0}
          top={0}
          bottom={0}
          w="400px"
          bg="white"
          boxShadow="-4px 0 12px rgba(0,0,0,0.1)"
          zIndex={1000}
          overflowY="auto"
        >
          <Box p={6}>
            {/* Header avec bouton fermer */}
            <Flex justify="space-between" align="start" mb={6}>
              <Text fontSize="lg" fontWeight="bold" color="gray.900">
                Détails de l'utilisateur
              </Text>
              <IconButton
                icon={<Text fontSize="xl">×</Text>}
                aria-label="Fermer"
                size="sm"
                variant="ghost"
                onClick={() => {
                  setIsDetailPanelOpen(false);
                  setSelectedUserDetail(null);
                }}
              />
            </Flex>

            {/* Photo et informations principales */}
            <VStack spacing={4} align="stretch" mb={6}>
              <Center>
                <Avatar
                  size="2xl"
                  src={selectedUserDetail.photo || "https://img.freepik.com/vecteurs-premium/icones-utilisateur-comprend-icones-utilisateur-symboles-icones-personnes-elements-conception-graphique-qualite-superieure_981536-526.jpg"}
                  name={`${selectedUserDetail.prenom || ''} ${selectedUserDetail.nom || ''}`}
                />
              </Center>
              <VStack spacing={1} align="center">
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  #P-{String(selectedUserDetail.id).padStart(3, '0')}
                </Text>
                <Text fontSize="xl" fontWeight="bold" color="gray.900" textAlign="center">
                  {selectedUserDetail.prenom || ''} {selectedUserDetail.nom || ''}
                </Text>
                <Text fontSize="sm" color="gray.600" textAlign="center">
                  P-{String(selectedUserDetail.id).padStart(3, '0')} {selectedUserDetail.rôle?.charAt(0).toUpperCase() + selectedUserDetail.rôle?.slice(1) || ''} {selectedUserDetail.specialty || ''}
                </Text>
              </VStack>
            </VStack>

            <Divider mb={6} />

            {/* À Propos */}
            {selectedUserDetail.à_propos && (
              <Box mb={6}>
                <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={2}>
                  À Propos
                </Text>
                <Text fontSize="sm" color="gray.600" lineHeight="1.6">
                  {selectedUserDetail.à_propos}
                </Text>
              </Box>
            )}

            {/* Contact */}
            <VStack spacing={3} align="stretch" mb={6}>
              <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                Contact
              </Text>
              {selectedUserDetail.téléphone && (
                <HStack spacing={2}>
                  <Icon as={MdPhone} color="gray.400" w="18px" h="18px" />
                  <Text fontSize="sm" color="gray.600">
                    {selectedUserDetail.téléphone}
                  </Text>
                </HStack>
              )}
              {selectedUserDetail.email && (
                <HStack spacing={2}>
                  <Icon as={MdEmail} color="gray.400" w="18px" h="18px" />
                  <Text fontSize="sm" color="gray.600">
                    {selectedUserDetail.email}
                  </Text>
                </HStack>
              )}
            </VStack>

            <Divider mb={6} />

            {/* Informations supplémentaires */}
            <VStack spacing={4} align="stretch" mb={6}>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.500">Ville</Text>
                <Text fontSize="sm" fontWeight="medium" color="gray.900">
                  {selectedUserDetail.ville || '---'}
                </Text>
              </HStack>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.500">Disponibles Actuelle</Text>
                <Badge
                  colorScheme={
                    selectedUserDetail.statut?.toLowerCase() === 'actif' ? 'green' :
                      selectedUserDetail.statut?.toLowerCase() === 'en mission' ? 'blue' :
                        selectedUserDetail.statut?.toLowerCase() === 'en pause' ? 'red' : 'gray'
                  }
                  borderRadius="full"
                >
                  {selectedUserDetail.statut || '---'}
                </Badge>
              </HStack>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.500">Dernière mission</Text>
                <Text fontSize="sm" fontWeight="medium" color="gray.900">
                  {selectedUserDetail.derniere_mission ? new Date(selectedUserDetail.derniere_mission).toLocaleDateString("fr-FR") : '---'}
                </Text>
              </HStack>
            </VStack>

            <Divider mb={6} />

            {/* Informations personnelles */}
            <VStack spacing={4} align="stretch" mb={6}>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.500">Date de naissance</Text>
                <Text fontSize="sm" fontWeight="medium" color="gray.900">
                  {selectedUserDetail.date_naissance ? new Date(selectedUserDetail.date_naissance).toLocaleDateString("fr-FR") : '---'}
                </Text>
              </HStack>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.500">Genre</Text>
                <Text fontSize="sm" fontWeight="medium" color="gray.900">
                  {selectedUserDetail.genre === 'homme' ? 'Homme' : selectedUserDetail.genre === 'femme' ? 'Femme' : selectedUserDetail.genre || '---'}
                </Text>
              </HStack>
            </VStack>

            {/* Bouton Voir le profil complet */}
            <Button
              colorScheme="blue"
              w="full"
              onClick={() => {
                handleView(selectedUserDetail.id);
                setIsDetailPanelOpen(false);
              }}
            >
              Voir le profil complet
            </Button>
          </Box>
        </Box>
      )}

    </Box>
  );
} 